const box = [
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue1.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue2.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue3.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue4.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue5.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue6.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue7.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue8.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogue9.png").default,
]

export default function NineCut(ninecut) {
    const views = []
    for(let x = 0; x < ninecut.width; x += 1) {
        for(let y = 0; y < ninecut.height; y += 1) {
            views.push({
                "x": x * (ninecut.tilewidth || 8),
                "y": y * (ninecut.tileheight || 8),
                "image": getNineCutImage(ninecut, x, y)
            })
        }
    }
    return views
}

function getNineCutImage(ninecut, x, y) {
    ninecut.images = ninecut.images || box
    if(y == 0) {
        if(x == 0) {
            return ninecut.images[0]
        } else if(x == ninecut.width - 1) {
            return ninecut.images[2]
        } else {
            return ninecut.images[1]
        }
    } else if(y == ninecut.height - 1) {
        if(x == 0) {
            return ninecut.images[6]
        } else if(x == ninecut.width - 1) {
            return ninecut.images[8]
        } else {
            return ninecut.images[7]
        }
    }
    if(x == 0) {
        return ninecut.images[3]
    } else if(x == ninecut.width - 1) {
        return ninecut.images[5]
    } else {
        return ninecut.images[4]
    }
}
